import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Menu, MenuItem } from "@mui/material";
import { DeleteSvg, EditSvg, FilterSvg, SwitchOffSvg, SwitchOnSvg } from "../../assets/svg/index.js";
import logo_icon from '../../assets/images/Logo/Bharat-Darshan-Logo.png';
import { api_urls } from "../../utils/api-urls/index.js";
import MainDatatable from '../../components/common/MainDatatable.jsx'
import * as BannerActions from '../../redux/actions/bannerAction.js';

const Banner = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { bannerData } = useSelector(state => state.bannerReducer)

    //! Handle Filter 
    const [filterText, setfilterText] = useState('');
    const uniqueRedirectPage = Array.from(new Set(bannerData?.flatMap(item => item?.redirect_to)));

    const [anchorEl, setAnchorEl] = useState(null);
    const handleOpenFilterDropDown = (event) => { setAnchorEl(event.currentTarget) };
    const handleCloseFilterDropDown = () => { setAnchorEl(null) };

    const handleFilter = (data) => {
        setfilterText(data)
        handleCloseFilterDropDown()
    };

    let filteredData;
    if (filterText.toLowerCase() === "all") {
        filteredData = bannerData;
    } else {
        filteredData = bannerData.length > 0 && bannerData.filter(item =>
            Object.values(item).some(value =>
                value && value?.toString().toLowerCase().includes(filterText?.toLowerCase())
            )
        );
    }

    //* Banner DataTable Columns
    const BannerColumns = [
        { name: 'S.No.', selector: row => filteredData?.length > 0 ? filteredData.length - filteredData.indexOf(row) : 1, style: { backGroundColor: "#000", paddingLeft: "20px" } },
        { name: 'Banner Name', selector: row => row?.banner },
        { name: <div onClick={handleOpenFilterDropDown} style={{ cursor: "pointer", display: "flex", alignItems: "center" }}><span>Redirect Page</span>  <FilterSvg h={'16'} /></div>, selector: row => row?.redirect_to?.join(', ') },
        { name: 'Image', cell: row => <img src={row?.image ? api_urls + row?.image : logo_icon} alt="Profile" style={{ width: '50px', height: '50px', borderRadius: '50%' }} /> },
        { name: 'Status', selector: row => <div onClick={() => dispatch(BannerActions?.changeBannerStatus({ bannerId: row?._id }))} style={{ cursor: "pointer" }}>{row?.status == 'Active' ? <SwitchOnSvg /> : <SwitchOffSvg />}</div> },
        {
            name: 'Action',
            cell: row => <div style={{ display: "flex", gap: "20px", alignItems: "center" }} >
                <div onClick={() => navigate('/banner/edit-banner', { state: { stateData: row } })} style={{ cursor: "pointer" }}><EditSvg /></div>
                <div onClick={() => dispatch(BannerActions.deleteBanner({ bannerId: row?._id }))} style={{ cursor: "pointer" }}><DeleteSvg /></div>
            </div>,
            width: "180px"
        },
    ]

    useEffect(() => {
        //! Dispatching API for Getting Banner
        dispatch(BannerActions.getBanner())
    }, []);

    return (
        <>
            <MainDatatable data={filteredData.length > 0 ? filteredData : [{ banner: "Test Data" }]} columns={BannerColumns} title={'Banner'} url={'/banner/add-banner'} />

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseFilterDropDown} >
                <MenuItem onClick={() => handleFilter('all')}>All</MenuItem>
                {uniqueRedirectPage?.map((value, index) => (
                    <MenuItem key={index} onClick={() => handleFilter(value)}>{value}</MenuItem>
                ))}
            </Menu>
        </ >
    );
}

export default Banner;